// This function allow to reference async chunks
__webpack_require__.u = function(chunkId) {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"596":"913699cb","766":"86446d9a","787":"7fd369dc"}[chunkId] + ".chunk.js";
};